module.exports = __webpack_public_path__ + "static/media/00_digginglight.3803e0e2.jpg";